<app-navbar></app-navbar>
<div class="container-flex">
  <div class="my-container">
    <div class="section-title-container">
      <div class="row">
        <h3 class="info-title">
          Diputados
          <button class="btn btn-success btn-sm ml-2" data-toggle="modal" data-target="#add-deputy">
            Agregar
          </button>
          <button class="btn btn-primary btn-sm ml-2" (click)="listarDiputados()">
            Refrescar tabla
          </button>
        </h3>
       <!--  <button type="button" class="btn btn-outline-dark outline-leer-mas">
          <a class="nav-link" routerLink="/inicio">Inicio</a>
        </button> -->
        <input class="ml-2" [(ngModel)]="nombreBuscar.find" type="text">
        <button class="btn btn-primary btn-sm ml-2" (click)="searchDeputy()">
          Buscar
        </button>
        <button class="btn btn-primary btn-sm ml-2" (click)="clearSearch()">
          Limpiar Buscador
        </button>
      </div>
    </div>
    <div class="section-body-container">
      <div class="m-5 p-5" *ngIf="!deputies || !deputies?.length">

      </div>
      <table class="news-table table table-striped table-borderless table-responsive table-hover"
        *ngIf="deputies && deputies?.length">
        <caption class="sr-only">Grupos Parlamentarios y Diputados</caption>
        <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Nombre</th>
            <th scope="col">Apellido</th>
            <th scope="col">Bancada</th>
            <th scope="col">Comisión</th>
            <th scope="col">cargo</th>
            <th scope="col">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of deputies | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize;; let i = index;"
            class="info-text">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ item.name | titlecase }}</td>
            <td>{{ item.lastname }}</td>
            <td>{{ item.country }}</td>
            <td>{{ item.commission.name }}</td>
            <td>{{ item.commission.position }}</td>
            <td class="text-center d-flex">
              <div class="mr-1">
                <button class="btn btn-primary btn-sm mt-1" data-toggle="modal" data-target="#view-news"
                  (click)="setDeputy(item)">
                  Ver
                </button>
              </div>
              <div class="mr-1">
                <button class="btn btn-warning btn-sm mt-1" data-toggle="modal" data-target="#update-news"
                  (click)="setDeputy(item)">
                  Editar
                </button>
              </div>
              <div>
                <button class="btn btn-danger btn-sm mt-1" data-toggle="modal" data-target="#delete-news"
                  (click)="setDeputy(item)">
                  Eliminar
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ngb-pagination class="d-flex justify-content-center" [collectionSize]="deputies?.length" [(page)]="page"
        [boundaryLinks]="true" [pageSize]="pageSize" size="sm" [maxSize]="5" [rotate]="true"
        *ngIf="deputies && deputies?.length">
      </ngb-pagination>
    </div>
  </div>
</div>

<!-- View Deputies ∆ Modal ∆ -->
<div class="modal fade" id="view-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="view-news-title" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header text-center  p-4 bg-dark">
        <h5 class="modal-title group-title w-100 text-white" id="view-news-title">Ver Diputado</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearDeputy()">
          <span aria-hidden="true" class="text-white">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group pb-4">
          <label for="view-name" class="group-title pb-1">
            Nombre
          </label>
          <input type="text" class="form-control" id="view-name" [value]="deputy.name" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-lastname" class="group-title pb-1">
            Apellido
          </label>
          <input type="text" class="form-control" id="view-lastname" [value]="deputy.lastname" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-bancada" class="group-title pb-1">
            Bancada
          </label>
          <input type="text" class="form-control" id="view-bancada" [value]="deputy.country" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-Directors" class="group-title pb-1">
            Cargo en Junta Directiva
          </label>
          <input type="text" class="form-control" id="view-Directors" [value]="deputy.boardOfDirectors.position"
            readonly>
        </div>
        <div class="form-group pb-4">
          <a href="http://" target="_blank" rel="noopener noreferrer"></a><label for="view-politico"
            class="group-title pb-1">
            Partido Politico
          </label>
          <input type="text" class="form-control" id="view-politico" [value]="deputy.politicalParty" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-creationDate" class="group-title pb-1">
            Comisión
          </label>
          <input type="text" class="form-control" id="view-comi" [value]="deputy.commission.name" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-creationDate" class="group-title pb-1">
            Cargo en Comisión
          </label>
          <input type="text" class="form-control" id="view-carcomi" [value]="deputy.commission.position" readonly>
        </div>
         <div class="form-group pb-4">
          <label for="view-group" class="group-title pb-1">
            Grupo Parlamentario
          </label>
          <input type="text" class="form-control" id="view-group" [value]="deputy?.parliamentaryGroups[0].name" readonly>
        </div>
        <div class="form-group pb-4">
          <label for="view-cargoG" class="group-title pb-1">
            Cargo en el Grupo Parlamentario
          </label>
          <input type="text" class="form-control" id="view-cargoG" [value]="deputy?.parliamentaryGroups[0].position"
            readonly>
        </div>
        <!-- <div class="form-group pb-4" *ngIf="parlaInput">
          <label for="view-group" class="group-title pb-1">
            Grupo Parlamentario
          </label>
          <input type="text" class="form-control" id="view-group" [value]="deputy?.parliamentaryGroups[0].name" readonly>
        </div>
        <div class="form-group pb-4" *ngIf="parlaInput">
          <label for="view-cargoG" class="group-title pb-1">
            Cargo en el Grupo Parlamentario
          </label>
          <input type="text" class="form-control" id="view-cargoG" [value]="deputy?.parliamentaryGroups[0].position"
            readonly>
        </div> -->
        <div class="form-group pb-4" *ngIf="blockInput">
          <label for="view-creationDate" class="group-title pb-1">
            Bloque de Mujeres
          </label>
          <input type="text" class="form-control" id="view-womenB" [value]="deputy.womensBlock.position" readonly>
        </div>
        <div class="form-group pb-4" *ngIf="exLeaderInput">
          <label for="view-creationDate" class="group-title pb-1">
            Es un Ex-Mandatario
          </label>
          <!-- <input type="text" class="form-control" id="view-Elead" [value]="deputy.exLeader" readonly> -->
        </div>
        <div *ngIf="deputy.eurolat">
          <label for="view-creationDate" class="group-title pb-1">
            Pertenece a Eurolat
          </label>
        </div>
        <!--  <div *ngIf="deputy.isActive">
          <h1>Activo</h1>
        </div> -->
        <!-- <select class="form-control" >
          <option *ngFor="let item of comisiones" [value]="item">
            {{ item|titlecase }}
          </option>
        </select> -->

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearDeputy()">
          Salir
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Deputies ∆ Modal ∆ -->
<div class="modal fade" id="add-deputy" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="add-news-title" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form #addNews="ngForm" (submit)="addDeputy()">
        <div class="modal-header text-center  p-4 bg-dark">
          <h5 class="modal-title group-title w-100 text-white" id="add-news-title">Agregar Diputado</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearDeputy()">
            <span aria-hidden="true" class="text-white">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group pb-4">
            <label for="add-name" class="group-title pb-1">
              Nombre
              <small style="color: red;">*</small>
            </label>
            <input type="text" class="form-control" id="add-name" #name="ngModel" [(ngModel)]="deputy.name" name="name"
              required aria-required="true" [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="add-lastname" class="group-title pb-1">
              Apellidos
              <small style="color: red;">*</small>
            </label>
            <input type="text" class="form-control" id="add-lastname" #lastname="ngModel" [(ngModel)]="deputy.lastname"
              name="lastname" required aria-required="true" [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="add-country" class="group-title pb-1">
              Bancada
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-bancada" #country="ngModel" [(ngModel)]="deputy.country" name="bancada"
              required aria-required="true" [disabled]="isSubmitting">
              <option *ngFor="let type of paises" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-board" class="group-title pb-1">
              Puesto en Junta Directiva
            </label>
            <select class="form-control" id="add-board" #boardOfDirectors="ngModel"
              [(ngModel)]="deputy.boardOfDirectors.position" name="boardPosition" aria-required="true"
              [disabled]="isSubmitting">
              <option *ngFor="let type of cargosj" [value]="type">{{type}}</option>
              <option value="">No Integrante</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-politicalparty" class="group-title pb-1">
              Partido Politico
            </label>
            <input type="text" class="form-control" id="add-politicalparty" #lastname="ngModel"
              [(ngModel)]="deputy.politicalParty" name="politicalParty" [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="add-comissionN" class="group-title pb-1">
              Comisión
            </label>
            <select class="form-control" id="add-comissionN" #commision.name="ngModel"
              [(ngModel)]="deputy.commission.name" name="pg" [disabled]="isSubmitting">
              <option *ngFor="let type of comisiones" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-comissionP" class="group-title pb-1">
              Cargo en la comision
            </label>
            <select class="form-control" id="add-comissionP" #commission.position="ngModel"
              [(ngModel)]="deputy.commission.position" name="position" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
          <!-- <div class="row">
            <div class="col text-primary" style="cursor: pointer;"><span (click)="hacertrue()">+ Agregar Grupo Parlamentario</span></div>
            <div class="col" style="cursor: pointer;"><span (click)="hacerfalse()">
                <p class="text-right text-danger">
                  - Eliminar Grupo Parlamentario
                </p>
              </span></div>
          </div> -->
          <div class="form-group pb-4">
            <label for="add-gp0" class="group-title pb-1">
              Grupo Parlamentario
            </label>
            <select class="form-control" id="add-gp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-cgp0" class="group-title pb-1">
              Cargo Grupo Parlamentario
            </label>
            <select class="form-control" id="add-cgp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
              <option value="No Integrante">No Integrante</option>
            </select>
          </div>

          <div *ngIf="segundoGrupo" class="form-group pb-4">
            <label for="add-gp1" class="group-title pb-1">
              Segundo Grupo Parlamentario
            </label>
            <select class="form-control" id="add-gp1" #parliamentaryGroups1.name="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[1].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div *ngIf="segundoGrupo" class="form-group pb-4">
            <label for="add-gcp1" class="group-title pb-1">
              Cargo Segundo Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gcp1" #parliamentaryGroups1.position="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[1].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>

          <div *ngIf="tercerGrupo" class="form-group pb-4">
            <label for="add-gp2" class="group-title pb-1">
              Tercer Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gp2" #parliamentaryGroups2.name="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[2].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div *ngIf="tercerGrupo" class="form-group pb-4">
            <label for="add-gcp2" class="group-title pb-1">
              Cargo Tercer Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gcp2" #parliamentaryGroups2.position="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[2].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-womensB" class="group-title pb-1">
              Bloque de mujeres
            </label>
            <select class="form-control" id="add-womensB" #womensBlock="ngModel"
              [(ngModel)]="deputy.womensBlock.position" name="position">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
              <option value="">No Integrante</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-EMandatario" class="group-title pb-1">
              Ex-Mandatario
            </label>
            <select class="form-control" id="add-EMandatario" #exLeader="ngModel" [(ngModel)]="valorex" name="position"
              (change)="hacertruePosition(valorex)">
              <option value="pertenece">Pertenece</option>
              <option value="noPertenece">No Pertenece</option>
            </select>
          </div>
          <div *ngIf="activePosition" class="form-group pb-4">
            <label for="add-leadpos" class="group-title pb-1">
              Puesto en Comisión Especial
            </label>
            <select class="form-control" id="add-leadpos" #leadpos="ngModel" [(ngModel)]="deputy.exLeaderPosition"
              name="leadPosition" aria-required="true" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-euro" class="group-title pb-1">
              EuroLat
            </label>
            <select class="form-control" id="add-euro" #euro="ngModel" [(ngModel)]="valoreuro" name="eurolat">
              <option value="pertenece">Pertenece</option>
              <option value="noPertenece">No Pertenece</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearDeputy()"
            [disabled]="isSubmitting">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" type="submit" [disabled]="isSubmitting">
            Agregar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Delete Deputies ∆ Modal ∆ -->
<div class="modal fade" id="delete-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="delete-news-title" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form #deleteNews="ngForm" (submit)="deleteEvent()">
        <div class="modal-header text-center  p-4 bg-dark">
          <h5 class="modal-title group-title w-100 text-white" id="delete-news-title">Eliminar Diputado</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearDeputy()">
            <span aria-hidden="true" class="text-white">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group pb-4">
            <label for="delete-title" class="group-title pb-1">
              Título
            </label>
            <input type="text" class="form-control" id="delete-title" [value]="deputy.name + deputy.lastname" readonly>
          </div>
          <div class="row">
            <div class="col-lg-12 text-center">
              <p class="info-text">
                ¿Está seguro de que desea eliminar este diputado?
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" (click)="clearDeputy()"
            [disabled]="isDeleting">
            Cancelar
          </button>
          <button type="button" class="btn btn-sm btn-danger" type="submit" [disabled]="isDeleting">
            Eliminar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Update Deputies ∆ Modal ∆ -->
<div class="modal fade" id="update-news" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="update-news-title" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form #updateNews="ngForm" (submit)="actulizarDiputado()">
        <div class="modal-header text-center  p-4 bg-dark">
          <h5 class="modal-title group-title w-100 text-white" id="update-news-title">Actualizar Diputado</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearDeputy()">
            <span aria-hidden="true" class="text-white">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group pb-4">
            <label for="add-title" class="group-title pb-1">
              Nombre
              <small style="color: red;">*</small>
            </label>
            <input type="text" class="form-control" id="add-title" #name="ngModel" [(ngModel)]="deputy.name" name="name"
              required aria-required="true" [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="upd-lastname" class="group-title pb-1">
              Apellidos
              <small style="color: red;">*</small>
            </label>
            <input type="text" class="form-control" id="upd-lastname" #lastname="ngModel" [(ngModel)]="deputy.lastname"
              name="lastname" required aria-required="true" [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="put-country" class="group-title pb-1">
              Bancada
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="put.coun" #country="ngModel" [(ngModel)]="deputy.country" name="country"
              required aria-required="true" [disabled]="isSubmitting">
              <option *ngFor="let type of paises" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="upd-board" class="group-title pb-1">
              Puesto en Junta Directiva
            </label>
            <select class="form-control" id="upd-board" #boardOfDirectors="ngModel"
              [(ngModel)]="deputy.boardOfDirectors.position" name="boardPosition" aria-required="true"
              [disabled]="isSubmitting">
              <option *ngFor="let type of cargosj" [value]="type">{{type}}</option>
              <option value="">No Integrante</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="upd-political" class="group-title pb-1">
              Partido Politico
              <!-- <small style="color: red;">*</small> -->
            </label>
            <input type="text" class="form-control" id="upd-political" #lastname="ngModel"
              [(ngModel)]="deputy.politicalParty" name="politicalParty" required aria-required="true"
              [readonly]="isSubmitting">
          </div>
          <div class="form-group pb-4">
            <label for="put-com" class="group-title pb-1">
              Comisión
              
            </label>
            <select class="form-control" id="put-com" #commision.name="ngModel" [(ngModel)]="deputy.commission.name"
              name="pg" required aria-required="true" [disabled]="isSubmitting">
              <option *ngFor="let type of comisiones" [value]="type">{{type}}</option>
            </select>
          </div>
          <p>
            actualmente su puesto es {{deputy.commission.position}}
          </p>
          <div class="form-group pb-4">
            <label for="put-comP" class="group-title pb-1">
              Cargo en la comision
              
            </label>
            <select class="form-control" id="put-comP" #commission.position="ngModel"
              [(ngModel)]="deputy.commission.position" name="position" required aria-required="true"
              [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
         <!--  <div class="row">
            <div class="col text-primary"><span (click)="hacertrue()">+ Agregar Grupo Parlamentario</span></div>
            <div class="col"><span (click)="hacerfalse()">
                <p class="text-right text-danger">
                  - Eliminar Grupo Parlamentario
                </p>
              </span></div>
          </div> -->
          <div class="form-group pb-4">
            <label for="up-gp0" class="group-title pb-1">
              Grupo Parlamentario
              
            </label>
            <select class="form-control" id="up -gp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="add-cgp0" class="group-title pb-1">
              Cargo Grupo Parlamentario
              
            </label>
            <select class="form-control" id="up-cgp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
         <!--  <div *ngIf="primerGrupo" class="form-group pb-4">
            <label for="add-gp0" class="group-title pb-1">
              Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div *ngIf="primerGrupo" class="form-group pb-4">
            <label for="add-cgp0" class="group-title pb-1">
              Cargo Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gp0" #parliamentaryGroups0Position="ngModel"
              [(ngModel)]="deputy?.parliamentaryGroups[0].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>

          <div *ngIf="segundoGrupo" class="form-group pb-4">
            <label for="add-gp1" class="group-title pb-1">
              Segundo Grupo Parlamentario
            </label>
            <select class="form-control" id="add-gp1" #parliamentaryGroups1.name="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[1].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div *ngIf="segundoGrupo" class="form-group pb-4">
            <label for="add-gcp1" class="group-title pb-1">
              Cargo Segundo Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gcp1" #parliamentaryGroups1.position="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[1].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>

          <div *ngIf="tercerGrupo" class="form-group pb-4">
            <label for="add-gp2" class="group-title pb-1">
              Tercer Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gp2" #parliamentaryGroups2.name="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[2].name" name="parliamentaryGroups1" [disabled]="isSubmitting">
              <option *ngFor="let type of grupos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div *ngIf="tercerGrupo" class="form-group pb-4">
            <label for="add-gcp2" class="group-title pb-1">
              Cargo Tercer Grupo Parlamentario
              <small style="color: red;">*</small>
            </label>
            <select class="form-control" id="add-gcp2" #parliamentaryGroups2.position="ngModel"
              [(ngModel)]="deputy.parliamentaryGroups[2].position" name="position1" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div> -->
          <div class="form-group pb-4">
            <label for="put-women" class="group-title pb-1">
              Bloque de mujeres
            </label>
            <select class="form-control" id="put-women" #womensBlock="ngModel" [(ngModel)]="deputy.womensBlock.position"
              name="position">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
              <option value="">No Integrante</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="upd-EMandatario" class="group-title pb-1">
              Ex-Mandatario
            </label>
            <select class="form-control" id="upd-EMandatario" #exLeader="ngModel" [(ngModel)]="valorex" name="position">
              <option value="pertenece">Pertenece</option>
              <option value="noPertenece">No Pertenece</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="upd-leadpos" class="group-title pb-1">
              Puesto en Comisión Especial
            </label>
            <select class="form-control" id="upd-leadpos" #leadpos="ngModel" [(ngModel)]="deputy.exLeaderPosition"
              name="leadPosition" aria-required="true" [disabled]="isSubmitting">
              <option *ngFor="let type of cargos" [value]="type">{{type}}</option>
            </select>
          </div>
          <div class="form-group pb-4">
            <label for="upd-euro" class="group-title pb-1">
              EuroLat
            </label>
            <p *ngIf="deputy.eurolat">
              Actualmente pertenece a eurolat
            </p>
            <p *ngIf="!deputy.eurolat">
              Actualmente no pertenece a eurolat
            </p>
            <select class="form-control" id="upd-euro" #euro="ngModel" [(ngModel)]="valoreuro" name="eurolat">
              <option value="pertenece">Pertenece</option>
              <option value="noPertenece">No Pertenece</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="clearDeputy()"
            [disabled]="isUpdating">
            Cancelar
          </button>
          <button type="button" class="btn btn-warning" type="submit" [disabled]="isUpdating">
            Actualizar Diputado
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
